import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { ILatestCaseStudiesProps } from '../components/latest-case-studies/latest-case-studies';
import { ITextProps } from '../components/text/text';
import { TextModel } from './text-model';
import { IButtonProps } from '../components/button/button';
import { ButtonModel } from './button-model';

export class LatestCaseStudiesModel extends ContentItem {
  get header(): ITextProps | null {
    const getHeader = get(this._config, 'elements.header.value[0]', null);

    const transformHeader = getHeader ? TextModel.create(getHeader) : null;
    return transformHeader as ITextProps;
  }

  get seeMoreButton(): IButtonProps {
    const getSeeMoreButton = get(
      this._config,
      'elements.see_more_button.value[0]',
      null
    );

    const transformButton = getSeeMoreButton
      ? ButtonModel.create(getSeeMoreButton)
      : null;
    return transformButton as IButtonProps;
  }

  public static create(data: ILatestCaseStudies): ILatestCaseStudiesProps {
    const { header, seeMoreButton } = new LatestCaseStudiesModel(data);
    return {
      header,
      seeMoreButton
    };
  }
}
